import React from 'react';
import { JoinModeProps } from '../../types';

export type JoinTypeDropdownProps = {
  state: JoinModeProps['state'];
  userInteraction: JoinModeProps['userInteraction'];
  outerJoinSupported: boolean;
  onSwitchToJoinTables: F0;
};

export const JoinTypeDropdown: React.FC<JoinTypeDropdownProps> = ({
  state,
  userInteraction,
  outerJoinSupported,
  onSwitchToJoinTables,
}) => {
  const joinTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    userInteraction({
      section: 'joinType',
      newValue: e.currentTarget.value,
    })(undefined);
    onSwitchToJoinTables();
  };

  return (
    <div>
      {!state.advanced && state.joinType === 'left' ? (
        <div className="margin-top-20">
          <a
            href="#"
            className=""
            onClick={userInteraction({ section: 'advanced' })}
          >
            Advanced: select join type
          </a>
          <a
            href="https://guide.trevor.io/hc/en-us/articles/6064427293853-Types-of-join"
            target="_blank"
          >
            <img className="helpIcon" src="/img/qm.png" />
          </a>
        </div>
      ) : (
        <div>
          <p>
            <b>Join type</b>
            <a
              href="https://guide.trevor.io/hc/en-us/articles/6064427293853-Types-of-join"
              target="_blank"
            >
              <img className="helpIcon" src="/img/qm.png" />
            </a>
          </p>
          <select
            value={state.joinType}
            className="form-control join-type-chooser"
            onChange={joinTypeChange}
          >
            <option value="left">Left join (default)</option>
            <option value="right">Right join</option>
            {outerJoinSupported && <option value="outer">Outer join</option>}
            <option value="inner">Inner join</option>
            <option value="cross">Cross join</option>
          </select>
        </div>
      )}
    </div>
  );
};
